import { wrapUrlSafe } from '@alltrails/shared/utils/languageSupport';
import Logo from '@alltrails/shared/denali/components/Logo';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import logWebHeaderAllTrailsLogoTapped from '@alltrails/analytics/events/logWebHeaderAllTrailsLogoTapped';
import useUser from 'hooks/useUser';
import { ComponentProps, useMemo } from 'react';
import * as styles from './styles/styles.module.scss';
import { HeaderBackground } from './types';
import useIsMobileSizedScreen from './useIsMobileSizedScreen';

type LogoLinkProps = {
  background?: HeaderBackground;
};

const LogoLink = ({ background }: LogoLinkProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const isMobile = useIsMobileSizedScreen();
  const user = useUser();

  const logoProps = useMemo<Pick<ComponentProps<typeof Logo>, 'color' | 'variant'>>(() => {
    if (user || isMobile) {
      return {
        color: background === 'transparentInverted' ? 'monochrome-light' : 'monochrome-dark',
        variant: 'symbol'
      };
    }
    return {
      color: background === 'transparentInverted' ? 'colored-light' : 'colored-dark',
      variant: 'logomark'
    };
  }, [background, isMobile, user]);

  return (
    <div className={styles.focusContainer}>
      <a
        className={styles.logoLink}
        data-testid="header-logo"
        href={wrapUrlSafe('/', languageRegionCode)}
        onClick={() => {
          logWebHeaderAllTrailsLogoTapped();
        }}
      >
        <Logo {...logoProps} size="sm" />
      </a>
    </div>
  );
};
export default LogoLink;
